import { css } from 'styled-components';

const bringIconToTheRight = css`
  input[type='checkbox'] + label {
    flex-direction: row-reverse;
    justify-content: space-between;
    svg {
      margin-right: 0;
    }
  }
`;

export const FlightContainerStyles = css`
  #FlightContainer {
    .container-controls {
      .container-field.icon-on-the-right {
        ${bringIconToTheRight};
      }
      @media (max-width: 767px) {
        ${bringIconToTheRight};
      }
    }
  }
`;
